import cn from 'classnames';
import styles from './styles.scss';
import connect from 'components/Shared/connect';
import { ListViewProduct } from 'models/ListViewProduct';
import { removeFavourite, addFavourite, getFavouriteProducts } from 'components/Favourites/actions';
import { FavouritesModel } from 'models/FavouritesModel';
import { isFavouritesPage } from 'models/FavouritesPageModel';
import { useState } from 'react';
import { IconCross } from 'components/Shared/Icon/themes/BGH-RD3/iconCross';
import { IconFavouriteToggle } from 'components/Shared/Icon/themes/BGH-RD3/iconFavouriteToggle';
import { NO_ELEMENT } from 'utils';
import { isCustomerPage } from 'models/CustomerPageModel';
import { useMounted } from 'hooks';
import { GtmProduct } from 'store/googleTagManager/types';

type OwnProps = Pick<ListViewProduct, 'productId'> & {
  gtmProduct?: GtmProduct;
  className?: string;
  label?: string;
};

interface MergedProps extends OwnProps {
  isFavourite: boolean;
  isFavouritesPage: boolean;
  addFavourite: () => Promise<void>;
  removeFavourite: () => Promise<void>;
}

interface StateProps {
  favourites: FavouritesModel['productIds'];
}

const _FavouriteToggle = (props: MergedProps) => {
  const [isAddingFavourite, setIsUpdatingFavourite] = useState(false);
  const isMounted = useMounted();

  const onAdd = () => {
    setIsUpdatingFavourite(true);
    props
      .addFavourite()
      .then(() => setIsUpdatingFavourite(false))
      .catch(() => setIsUpdatingFavourite(false));
  };

  const onRemove = () => {
    setIsUpdatingFavourite(true);
    props
      .removeFavourite()
      .then(() => isMounted() && setIsUpdatingFavourite(false))
      .catch(() => isMounted() && setIsUpdatingFavourite(false));
  };

  const isOnFavouritesPage = props.isFavourite && props.isFavouritesPage;

  return (
    <>
      <div
        onClick={props.isFavourite ? onRemove : onAdd}
        className={cn(
          styles.favouriteToggle,
          { [styles.isFavourite]: props.isFavourite },
          { [styles.isAddingFavourite]: isAddingFavourite },
          props.className
        )}
      >
        {isOnFavouritesPage ? (
          <div className={styles.iconCross}>
            <IconCross />
          </div>
        ) : (
          <div className={styles.iconFavouriteToggle}>
            <IconFavouriteToggle />
          </div>
        )}
        {props.label ? <p className={styles.label}>{props.label}</p> : NO_ELEMENT}
      </div>
    </>
  );
};

export const FavouriteToggle = connect<MergedProps, OwnProps, StateProps>(
  state => ({
    favourites: getFavouriteProducts(state),
    isFavouritesPage: isFavouritesPage(state.currentPage) || isCustomerPage(state.currentPage)
  }),
  (dispatch, { productId, gtmProduct }) => ({
    addFavourite: () => dispatch(addFavourite({ productId }, gtmProduct)),
    removeFavourite: () => dispatch(removeFavourite({ productId }, gtmProduct))
  }),
  ({ favourites, ...s }, d, p) => ({
    ...s,
    ...d,
    ...p,
    isFavourite: favourites?.includes(p.productId)
  })
)(_FavouriteToggle);

export default FavouriteToggle;